import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconLeftChevronOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M18.309.22a.75.75 0 0 0-1.061 0L5.468 12l11.78 11.781a.751.751 0 0 0 1.06-1.061L7.589 12l10.72-10.72a.75.75 0 0 0 0-1.06" /></svg>
);
